export default (() => {});
//# sourceMappingURL=edgeTarget.js.map